import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { useAppSelector } from "../../../../../../redux";
import {
  FlexColumn,
  FlexRow,
  FlexRowCenter,
} from "../../../../../Common/Styles";
import CircleModalProps from "./CircleModal";

const ModalHeader = ({
  isSuccessModal,
  circleName,
}: CircleModalProps.ModalHeaderProps) => {
  const { typography, Color } = useTheme();
  const { listOfCircles, editCircleId } = useAppSelector(
    (state) => state.circle
  );

  return (
    <ModalHeaderContainer>
      <Circle>
        <SmallCircle />
      </Circle>
      <Container>
        <Components.Text
          style={{ tokenStyle: typography.Heading.L }}
          text={
            editCircleId
              ? isSuccessModal
                ? "Changes saved!"
                : "Edit circle"
              : isSuccessModal
              ? "Circle created!"
              : "Create a circle"
          }
          fontWeight="font-weight-semibold"
          lineHeight="line-height-750"
          color={
            isSuccessModal
              ? Color.text["text-emphasize-brand-bolder"].value
              : Color.text["text-primary"].value
          }
        />
        <Wrapper $isSuccessModal={isSuccessModal}>
          <Components.Text
            style={{ tokenStyle: typography.Body.S }}
            text={
              isSuccessModal
                ? `You've ${editCircleId ? "updated" : "created"}  ${
                    listOfCircles.length ? "" : "your first"
                  } Circle -> `
                : "Group, manage and curate your newsfeed by topics, categories and users."
            }
            lineHeight="line-height-50"
          />
          {isSuccessModal && (
            <Components.Button
              color="Neutral"
              kind="Primary"
              size="XS"
              disabled={false}
              label={circleName}
              onClick={() => {}}
            />
          )}
        </Wrapper>
      </Container>
    </ModalHeaderContainer>
  );
};

export default ModalHeader;

const ModalHeaderContainer = styled(FlexRow)`
  padding: ${({ theme }) => theme.spacing["spacing-9"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const Circle = styled(FlexRowCenter)`
  width: 101px;
  min-width: 101px;
  height: 101px;
  border-radius: 100%;
  background: linear-gradient(
    93deg,
    ${({ theme }) => theme.Color.background.brand.default.value} 2.1%,
    #b175fd 112.77%
  );
`;
const SmallCircle = styled.div`
  width: 51px;
  min-width: 51px;
  height: 51px;
  border-radius: 100%;
  border: 4px solid ${({ theme }) => theme.Color.icon["icon-inverse"].value};
  background: linear-gradient(
    93deg,
    ${({ theme }) => theme.Color.background.brand.default.value} 2.1%,
    #b175fd 112.77%
  );
`;

const Wrapper = styled.div<{ $isSuccessModal: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme, $isSuccessModal }) =>
      theme.spacing[$isSuccessModal ? "spacing-2" : "spacing-1"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: ${({ theme, $isSuccessModal }) =>
    $isSuccessModal
      ? theme.Color.background.brand.subtler["default-hover"].value
      : theme.Color.elevation.surface["surface-secondary"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;

  & button label {
    font-weight: 600;
  }
`;

const Container = styled(FlexColumn)`
  width: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
